import { useEffect } from 'react'
import { PolicyPage, PageShell } from './PolicyPage'
export default function DeleteAccount() {
  useEffect(() => { document.title = 'Delete Account — SYNINN' }, [])
  return (
    <PageShell title="Delete Your Account" subtitle="We process all requests within 30 days">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
        {[
          { step: '1', text: 'Open the SYNINN app and log in to your account.' },
          { step: '2', text: 'Tap the Profile icon at the top right of the home screen.' },
          { step: '3', text: 'Scroll down and tap Edit Profile.' },
          { step: '4', text: 'Tap Delete My Account at the bottom and confirm.' },
          { step: '5', text: 'Your account and data will be permanently deleted within 30 days.' },
        ].map(item => (
          <div key={item.step} style={{ display: 'flex', alignItems: 'flex-start', gap: '14px', padding: '14px 16px', background: '#111', border: '1px solid #1a1a1a', borderRadius: '10px' }}>
            <div style={{ width: '28px', height: '28px', borderRadius: '50%', background: '#1a1200', border: '1px solid #C9A84C44', color: '#C9A84C', fontSize: '11px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{item.step}</div>
            <span style={{ fontSize: '13px', color: '#ccc', lineHeight: '1.6' }}>{item.text}</span>
          </div>
        ))}
      </div>
      <div style={{ padding: '16px', background: '#1a1200', border: '1px solid #C9A84C33', borderRadius: '10px', fontSize: '13px', color: '#C9A84C', marginBottom: '24px', lineHeight: '1.7' }}>
        Cannot access the app? Email <strong>support@syninn.com</strong> with subject "Account Deletion Request" and your registered email address.
      </div>
      <div style={{ padding: '16px', background: '#111', border: '1px solid #1a1a1a', borderRadius: '12px' }}>
        <div style={{ fontSize: '10px', color: '#C9A84C', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '12px', fontWeight: '600' }}>What data is deleted</div>
        {[
          { label: 'Name, email, phone number', status: 'Deleted', color: '#E05252' },
          { label: 'Booking history', status: 'Deleted', color: '#E05252' },
          { label: 'Wallet balance and transactions', status: 'Deleted', color: '#E05252' },
          { label: 'Loyalty points', status: 'Deleted', color: '#E05252' },
          { label: 'Reviews and ratings', status: 'Deleted', color: '#E05252' },
          { label: 'Discount codes', status: 'Deleted', color: '#E05252' },
          { label: 'Anonymous analytics', status: 'Retained (anonymised)', color: '#C9A84C' },
        ].map(item => (
          <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '9px 0', borderBottom: '1px solid #1a1a1a', fontSize: '12px' }}>
            <span style={{ color: '#888' }}>{item.label}</span>
            <span style={{ color: item.color, fontWeight: '600' }}>{item.status}</span>
          </div>
        ))}
      </div>
    </PageShell>
  )
}